import { Route } from '@angular/router';

import { UnauthenticatedGuard } from './authentication-guard/unauthenticated.guard';

export const AUTH_ROUTES: Route[] = [
  {
    path: 'welcome',
    loadComponent: () => import('./welcome-page/welcome-page.component').then((m) => m.WelcomePageComponent),
    pathMatch: 'full',
    canActivate: [UnauthenticatedGuard]
  },
  {
    path: 'cognito-callback',
    loadComponent: () =>
      import('./cognito-callback-page/cognito-callback-page.component').then((m) => m.CognitoCallbackPageComponent),
    pathMatch: 'full'
  },
  {
    path: 'password-change',
    pathMatch: 'full',
    loadComponent: () =>
      import('./password-update-page/password-update-page.component').then((m) => m.PasswordUpdatePageComponent)
  }
];
